export default function (_text, length, minThreshold = 0) {
  let text = _text;
  if (text && text.length > (length + minThreshold)) {
    text = text.substr(0, length);
    text += '...';
  }
  return text;
}
